import React from 'react'
import {Image,Header,Icon } from 'semantic-ui-react'
import mainlogo from './inspektLogo_lightgrey.png'

const footer = ()=>(

  <div className='footer'>
      <div>
        <Header className='footertitle' as='h4' color='grey'>Site développé
            <Header.Subheader>avec passion</Header.Subheader>
        </Header>
      </div>
      <div className='inspektlogo'>
        <Image src={mainlogo} size='tiny'/>
      </div>
      <div>
          <a href='https://inspekt.fr/' target='_blank' title='Inspekt.fr'>
            <Icon name='linkify' size='large' color='grey'/>
          </a>
          <a href='https://www.linkedin.com/in/mickael-le-gallic-99883a62/' target='_blank' title='Inspekt.fr'>
            <Icon name='linkedin' size='large' color='grey'/>
          </a>
          
        
      </div>
  </div>

)

export default footer